import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { ArrowDown } from './glyphs/ArrowDown.tsx';
import { ArrowUp } from './glyphs/ArrowUp.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ArrowContainer = styled.span({
	marginLeft: token('space.200'),
	marginRight: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StaticNudgeContainer = styled.span({
	display: 'flex',
	alignContent: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextContainer = styled.span({
	alignSelf: 'center',
});

/**
 * A static Nudge that can be shown to the user to inform them about the newly released features or highlight specific portion
 * This is an evolving component, currently it supports arrows in two directions UP | DOWN,
 * More directions can be added and customization can be built into this component.
 * @param {string} position Position of the Arrow, Currently supported options UP | DOWN
 * @param {string | JSX.Element} text Text that should be displayed along with the Arrows
 * @param {{}} customStyles Custom CSS styles applied to the whole Static Nudge
 * @returns
 */
export const StaticNudge = ({
	position,
	text,
	customStyles,
}: {
	position: 'up' | 'down';
	text: string | JSX.Element;
	customStyles?: {};
}) => {
	const Arrow = position === 'up' ? ArrowUp : ArrowDown;
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
		<StaticNudgeContainer style={{ ...customStyles }}>
			<ArrowContainer>
				<Arrow />
			</ArrowContainer>
			<TextContainer>{text}</TextContainer>
		</StaticNudgeContainer>
	);
};
